var _rect, _path, _path2, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _circle, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHubopsConfigure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 99,
    height: 99,
    rx: 11.5,
    fill: "#F8FBFF",
    stroke: "#EBF1FA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3254 24.0985L70.3552 34.9382V74.0596L20.0986 74.5523V34.9382L45.3254 24.0985Z",
    fill: "#9775CF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3388 36.3866L48.1831 25.496L44.9426 24.1971L20 34.688V74.4537H23.3388V36.3866Z",
    fill: "#803EEC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 38.9202,
    y: 31.2921,
    width: 12.4164,
    height: 1.57668,
    fill: "#D9D9D9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 38.9202,
    y: 34.4455,
    width: 12.4164,
    height: 1.57668,
    fill: "#D9D9D9"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 38.9202,
    y: 37.4018,
    width: 12.4164,
    height: 1.57668,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24.1388,
    y: 42.526,
    width: 43.1616,
    height: 21.4823,
    fill: "#6536B1"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 45.621,
    y: 49.2272,
    width: 14.5843,
    height: 14.3872,
    fill: "#FEDB7C"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 46.8035,
    y: 56.1252,
    width: 6.70089,
    height: 4.33587,
    fill: "white"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 50.7452,
    y: 49.2272,
    width: 4.92712,
    height: 6.30672,
    fill: "#FEBD89"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 45.621,
    y: 49.2272,
    width: 1.18251,
    height: 14.3872,
    fill: "#FEC436"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 30.0513,
    y: 49.2272,
    width: 14.5843,
    height: 14.3872,
    fill: "#FEDB7C"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 31.2338,
    y: 56.1252,
    width: 6.70089,
    height: 4.33587,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 35.1755,
    y: 49.2272,
    width: 4.92712,
    height: 6.30672,
    fill: "#FEBD89"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 30.0513,
    y: 49.2272,
    width: 1.18251,
    height: 14.3872,
    fill: "#FEC436"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 39.3143,
    y: 60.0665,
    width: 14.5843,
    height: 14.3872,
    fill: "#FEDB7C"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 40.4968,
    y: 66.9646,
    width: 6.70089,
    height: 4.33587,
    fill: "white"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 44.4385,
    y: 60.0667,
    width: 4.92712,
    height: 6.30672,
    fill: "#FEBD89"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 39.3143,
    y: 60.0665,
    width: 1.18251,
    height: 14.3872,
    fill: "#FEC436"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 24.3359,
    y: 60.0665,
    width: 14.5843,
    height: 14.3872,
    fill: "#FEDB7C"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 25.5184,
    y: 66.9646,
    width: 6.70089,
    height: 4.33587,
    fill: "white"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 29.4601,
    y: 60.0667,
    width: 4.92712,
    height: 6.30672,
    fill: "#FEBD89"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 24.3359,
    y: 60.0665,
    width: 1.18251,
    height: 14.3872,
    fill: "#FEC436"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 53.8986,
    y: 60.0665,
    width: 14.5843,
    height: 14.3872,
    fill: "#FEDB7C"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 55.0812,
    y: 66.9646,
    width: 6.70089,
    height: 4.33587,
    fill: "white"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 59.0229,
    y: 60.0667,
    width: 4.92712,
    height: 6.30672,
    fill: "#FEBD89"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 53.8986,
    y: 60.0665,
    width: 1.18251,
    height: 14.3872,
    fill: "#FEC436"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 63.334,
    cy: 60.436,
    r: 15.1509,
    fill: "#A2C8F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.2793 51.152C64.9093 51 64.4393 51 63.5003 51C62.5613 51 62.0923 51 61.7213 51.152C61.4772 51.2517 61.2552 51.3988 61.0682 51.5846C60.8811 51.7705 60.7326 51.9915 60.6313 52.235C60.5373 52.458 60.5013 52.719 60.4863 53.098C60.4792 53.3725 60.4024 53.6407 60.2631 53.8774C60.1239 54.114 59.9268 54.3114 59.6903 54.451C59.4491 54.5851 59.1779 54.6561 58.9018 54.6575C58.6258 54.6589 58.3539 54.5907 58.1113 54.459C57.7733 54.281 57.5283 54.183 57.2863 54.151C56.7569 54.0819 56.2216 54.2242 55.7963 54.547C55.4783 54.789 55.2433 55.193 54.7743 56C54.3043 56.807 54.0703 57.21 54.0173 57.605C53.9473 58.131 54.0913 58.663 54.4173 59.084C54.5653 59.276 54.7743 59.437 55.0973 59.639C55.5743 59.936 55.8803 60.442 55.8803 61C55.8803 61.558 55.5743 62.064 55.0983 62.36C54.7743 62.563 54.5653 62.724 54.4163 62.916C54.2559 63.1242 54.1381 63.362 54.0696 63.6158C54.0011 63.8696 53.9834 64.1343 54.0173 64.395C54.0703 64.789 54.3043 65.193 54.7743 66C55.2443 66.807 55.4783 67.21 55.7963 67.453C56.2203 67.776 56.7563 67.918 57.2863 67.849C57.5283 67.817 57.7733 67.719 58.1113 67.541C58.354 67.4092 58.6261 67.3408 58.9023 67.3422C59.1786 67.3436 59.4499 67.4147 59.6913 67.549C60.1773 67.829 60.4653 68.344 60.4863 68.902C60.5013 69.282 60.5373 69.542 60.6313 69.765C60.8353 70.255 61.2273 70.645 61.7213 70.848C62.0913 71 62.5613 71 63.5003 71C64.4393 71 64.9093 71 65.2793 70.848C65.5234 70.7483 65.7454 70.6012 65.9325 70.4154C66.1195 70.2295 66.268 70.0085 66.3693 69.765C66.4633 69.542 66.4993 69.282 66.5143 68.902C66.5343 68.344 66.8233 67.828 67.3103 67.549C67.5516 67.4149 67.8228 67.3439 68.0988 67.3425C68.3748 67.3411 68.6467 67.4093 68.8893 67.541C69.2273 67.719 69.4723 67.817 69.7143 67.849C70.2443 67.919 70.7803 67.776 71.2043 67.453C71.5223 67.211 71.7573 66.807 72.2263 66C72.6963 65.193 72.9303 64.79 72.9833 64.395C73.0171 64.1343 72.9992 63.8695 72.9306 63.6157C72.8619 63.3619 72.7439 63.1241 72.5833 62.916C72.4353 62.724 72.2263 62.563 71.9033 62.361C71.4263 62.064 71.1203 61.558 71.1203 61C71.1203 60.442 71.4263 59.936 71.9023 59.64C72.2263 59.437 72.4353 59.276 72.5843 59.084C72.7447 58.8758 72.8626 58.638 72.931 58.3842C72.9995 58.1304 73.0173 57.8657 72.9833 57.605C72.9303 57.211 72.6963 56.807 72.2263 56C71.7563 55.193 71.5223 54.79 71.2043 54.547C70.779 54.2242 70.2437 54.0819 69.7143 54.151C69.4723 54.183 69.2273 54.281 68.8893 54.459C68.6466 54.5908 68.3745 54.6592 68.0983 54.6578C67.8221 54.6564 67.5507 54.5853 67.3093 54.451C67.073 54.3113 66.8761 54.1139 66.7371 53.8772C66.598 53.6405 66.5213 53.3724 66.5143 53.098C66.4993 52.718 66.4633 52.458 66.3693 52.235C66.268 51.9915 66.1195 51.7705 65.9325 51.5846C65.7454 51.3988 65.5234 51.2517 65.2793 51.152ZM63.5003 64C65.1703 64 66.5233 62.657 66.5233 61C66.5233 59.343 65.1693 58 63.5003 58C61.8313 58 60.4773 59.343 60.4773 61C60.4773 62.657 61.8313 64 63.5003 64Z",
    fill: "#142EB4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHubopsConfigure);
export default __webpack_public_path__ + "static/media/hubops-configure.537d28dd61d3fa41933489ffccb4158d.svg";
export { ForwardRef as ReactComponent };